import 'rxjs/add/operator/toPromise';
import {
  NavController,
  ToastController,
  LoadingController,
  AlertController,
  ViewController,
  Config,
  Select,
  ModalController,
  Modal,
  ActionSheetController,
  Platform
} from 'ionic-angular';
import {
  Injectable
} from '@angular/core';
import {
  CalendarModal,
  CalendarModalOptions,
  DayConfig,
  CalendarResult
} from "ion2-calendar";
import swal from "sweetalert";
import { CameraOptions, Camera } from '@ionic-native/camera';
import { FileChooser } from '@ionic-native/file-chooser';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { Base64 } from '@ionic-native/base64';
import { FilePath } from '@ionic-native/file-path';
import { File } from '@ionic-native/file';
import { ImageViewerController } from 'ionic-img-viewer';
import { RepositoryMyRadiant } from '..';
import { cmpFilterKaryawan } from '@src/components/presensi';
import { Api } from '@providers/api/api';

@Injectable()
export class Helper {
  loading: any;
  startDate: any = new Date;
  valDateJarak: any;
  today = this.getToday();
  imageSelected: any;
  imageNameSelected : any;
  stateActionSheet: boolean;
  imageUrlSelected: string;
  monthNamesLong = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  monthNamesShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
  ];
  dayNamesLong =['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  dayNamesShort =['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];

  constructor(
    public toastCtrl        : ToastController,
    public loadingCtrl      : LoadingController,
    public alertCtrl        : AlertController,
    public modalCtrl        : ModalController,
    public actionSheetCtrl  : ActionSheetController,
    public camera           : Camera,
    public fileChooser      : FileChooser,
    public photoViewer      : PhotoViewer,
    private base64          : Base64,
    private filepath        : FilePath,
    public file             : File, 
    public platform         : Platform,
    public imageViewerCtrl  : ImageViewerController,
    public repositoryProvider : RepositoryMyRadiant,
    public api              : Api
  ) {
    // this._imageViewerCtrl = imageViewerCtrl;
  }

  ifvalnull(val,valdefault){
    return val == null || val == undefined || val == "" ? valdefault : val;
  }

  getToday() {
    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    let firstDay = new Date(y, m, 1);
    let lastDay = new Date(y, m + 1, 0);
    // let day = date.getDate().toString().padStart(2, '0');
    // let month = (1 + m).padStart(2, '0');
    let out = {
      // tanggal: day,
      // bulan:month,
      tahun: y,
      awal: this.dateToString(firstDay, 'dmy'),
      akhir: this.dateToString(lastDay, 'dmy'),
      awalYmd: this.dateToString(firstDay, 'ymd'),
      akhirYmd: this.dateToString(lastDay, 'ymd'),
      obj: {
        awal: firstDay,
        akhir: lastDay
      }
    };
    return out;
  }

  convert_date(date,opts?:any){
    let new_date = '';
    if (date == '-' || date == null || date == 'null') {
      new_date = '';
    }else{
      date = new Date(date);
      let day = date.getDate(),month = date.getMonth()+1, year = date.getFullYear();
      let separator = this.ifvalnull(opts.separator,'-');
      switch (this.ifvalnull(opts.formatDay,'dd')) {
        case 'd':
          day = day;
          break;
        case 'D':
          day = this.dayNamesShort[date.getDay()];
          break;
        case 'dd':
          day = day < 10 ? '0'+day : day;    
          break;
        case 'DD':
          day = this.dayNamesLong[date.getDay()];   
          break;
      default:
        day = day;
        break;
      }
      switch (this.ifvalnull(opts.formatMonth,'mm')) {
          case 'm':
          month = month;
            break;
          case 'M':
          month = this.monthNamesShort[date.getMonth()];
            break;
          case 'mm':
          month = month < 10 ? '0'+month : month;    
            break;
          case 'MM':
          month = this.monthNamesLong[date.getMonth()];   
            break;
        default:
          month = day;
          break;
      }
      switch (this.ifvalnull(opts.formatYear,'Y')) {
        case 'y':
        year = year.toString().substring(2) < 10 ? '0'+year.toString().substring(2) : year.toString().substring(2);
          break;
      default:
        year = year;
        break;
    }
    switch (this.ifvalnull(opts.format,'dmy')) {
      case 'dmy':
        new_date = day + separator + month + separator + year;
        break;
      case 'ymd':
        new_date = year + separator + month + separator + day;
        break;
      case 'mdy':
        new_date = month + separator + day + separator + year;
        break;
      case 'dym':
        new_date = day + separator + month + separator + year;
        break;
      case 'ydm':
        new_date = year + separator + day + separator + month;
        break;
      default:
        break;
    }
  }
  return new_date;
  }

  presentSwal(title = '', msg = '', status = 'success') {
    swal(title, msg, status);
  }

  presentSwalFeedback(successCallback?:any) {
    let el = document.createElement("div");
    /* <div class="rate">
          <input type="radio" id="star5" name="rate-radio" value="5" />
          <label for="star5" title="text"></label>
          <input type="radio" id="star4" name="rate-radio" value="4" />
          <label for="star4" title="text"></label>
          <input type="radio" id="star3" name="rate-radio" value="3" />
          <label for="star3" title="text"></label>
          <input type="radio" id="star2" name="rate-radio" value="2" />
          <label for="star2" title="text"></label>
          <input type="radio" id="star1" name="rate-radio" value="1" />
          <label for="star1" title="text"></label>
        </div> */
    el.innerHTML = `
      <textarea class="swal-content__textarea" rows="7" id="notes-feedback" placeholder="Enter Notes Here.."></textarea>
      <div class="select-feedback">
        <select id="category-feedback">
          <option value="none" disabled selected hidden> Select Category </option>
          <option value="3">Marketing</option>
          <option value="4">Project</option>
          <option value="2">Presensi</option>
          <option value="8">Activity</option>
          <option value="7">Advance</option>
          <option value="1">Aproval ERP</option>
        </select>
      </div>
    `;
    swal(
      "Feedback", "","",
      {
        dangerMode:false,
        buttons:["Cancel",'Submit'],
        content:{
          element:el,
        }
      }
    )
    .then((value) => {
      if (value) {
        let notes   = document.getElementById('notes-feedback')['value'];
        let category =document.getElementById("category-feedback")['value'];
        // let rating  = 0;
        // const rateCmp = Array.from(document.getElementsByName('rate-radio'));
        // rateCmp.forEach((cmp) => {
        //     if (cmp['checked']) {
        //       rating = cmp['value'];
        //     }
        // });
        document.getElementById('notes-feedback')['value'] = "";
        successCallback(notes,category);
      }else{
      }
    }); 
  }

  showCamera(successCallback?:any) {
    let me = this;
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum: true,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection: this.camera.Direction.FRONT
    }

    this.camera.getPicture(options).then((uri) => {
      successCallback(uri);
    }, (err) => {
      // Handle error
    });
  }

  setFile(url,callback?:any){
    let me = this;
    this.filepath.resolveNativePath(url).then(imageData => {
      me.imageUrlSelected = imageData;
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {
        me.imageNameSelected = file.name;
        callback(file.name);
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {
        me.imageSelected = base64File;
      }, (err) => {
        console.log(err);
      });
    })
    .catch(err => console.log(err));
  }

  chooseFile(successCallback?:any) {
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.imageSelected = uri;
        this.imageNameSelected = uri;
        successCallback(uri);
      })
      .catch(e => console.log(e));
  }

  presentActionSheetGallery(successCallback?:any){
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Pick file',
      buttons: [
        {
          text: 'From Gallery',

          handler: () => {
            this.stateActionSheet = true;
            this.chooseFile(successCallback);
          }
        },
        {
          text: 'From Camera',
          handler: () => {
            this.stateActionSheet = true;
            this.showCamera(successCallback);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            this.stateActionSheet = true;
            console.log('Cancel clicked');
          }
        }
      ]
    });

    actionSheet.present();
  }

  async set_close(class_btn){
    document.getElementsByClassName("swal-overlay--show-modal")[0].id = 'close-swal-'+class_btn;
  }

  presentSwalCustomContent(opts,successCallback){
    this.imageSelected = null;
    let el = document.createElement("div");
    el.innerHTML = this.ifvalnull(opts.content,"");
    //bikin baru
    let class_btn = this.ifvalnull(opts.generated_class_btn,'btn-capture-img');
    let class_lbl = this.ifvalnull(opts.generated_class_label,'name-capture-img');
    // console.log(opts,'options');

    /* KONFIGURASI  */
    this.stateActionSheet = true;
    if (this.ifvalnull(opts.eventListenerContent,false)) {
      let cmpListeners = this.ifvalnull(opts.cmpListeners,"");
      if (cmpListeners == 'progress-presensi') {
        document.addEventListener("click", event => {
          if (event.target['classList'].contains('close-sweetalert-'+class_btn)) {
            this.set_close(class_btn).then( () => {
              document.getElementById('close-swal-'+class_btn).click();
            })
          }
          if (event.target['classList'].contains(class_btn)) {
            // console.log(event);
            if (this.stateActionSheet) {
              this.presentActionSheetGallery((uri) => {
                this.setFile(uri,(image) => {
                  let img = document.getElementsByClassName(class_lbl);
                  // console.log(img,"class => ",class_lbl,"document.getElementsByClassName("+this.ifvalnull(opts.generated_class_label,'name-capture-img')+")");
                  if (img.length > 0) {
                    img[0].textContent = image;
                  }
                });
              });
              this.stateActionSheet = false;
            }
          }
          if (event.target['classList'].contains(class_lbl)) {
            // if (this.stateActionSheet) {
              this.previewFoto(this.imageUrlSelected);
              // this.stateActionSheet = false;
            // }
          }
        });
      }
      if (cmpListeners == 'approve-overtime') {
        document.addEventListener("click", event => {
          if (event.target['classList'].contains(class_btn)) {
            // console.log(event);
            if (this.stateActionSheet) {
              this.presentActionSheetGallery((uri) => {
                this.setFile(uri,(image) => {
                  let img = document.getElementsByClassName(class_lbl);
                  // console.log(img,"class => ",class_lbl,"document.getElementsByClassName("+this.ifvalnull(opts.generated_class_label,'name-capture-img')+")");
                  if (img.length > 0) {
                    img[0].textContent = image;
                  }
                });
              });
              this.stateActionSheet = false;
            }
          }
          if (event.target['classList'].contains(class_lbl)) {
            // if (this.stateActionSheet) {
              this.previewFoto(this.imageUrlSelected);
              // this.stateActionSheet = false;
            // }
          }
        });
      }
    }
    /* SHOW SWAL */
    swal(
      this.ifvalnull(opts.title,"Information"), this.ifvalnull(opts.desc,""),this.ifvalnull(opts.type,""),
      {
        dangerMode:this.ifvalnull(opts.dangerMode,false),
        className: "popup-productivity",
        buttons: opts.buttonConfirm === false ? ["Close"] : ["Cancel",this.ifvalnull(opts.buttonConfirm,"Submit")],
        content:{
          element:el,
        }
      }
    )
    .then((value) => {
      if (value) {
        successCallback(value);
      }else{
      }
    }); 
  }

  presentSwalCustomContentWithButton(opts,successCallback){
    this.imageSelected = null;
    let el = document.createElement("div");
    el.innerHTML = this.ifvalnull(opts.content,"");
    //bikin baru
    let class_btn = this.ifvalnull(opts.generated_class_btn,'btn-capture-img');
    let class_lbl = this.ifvalnull(opts.generated_class_label,'name-capture-img');
    // console.log(opts,'options');

    /* KONFIGURASI  */
    this.stateActionSheet = true;
    if (this.ifvalnull(opts.eventListenerContent,false)) {
      let cmpListeners = this.ifvalnull(opts.cmpListeners,"");
      if (cmpListeners == 'progress-presensi') {
        document.addEventListener("click", event => {
          if (event.target['classList'].contains('close-sweetalert-'+class_btn)) {
            this.set_close(class_btn).then( () => {
              document.getElementById('close-swal-'+class_btn).click();
            })
          }
          if (event.target['classList'].contains(class_btn)) {
            // console.log(event);
            if (this.stateActionSheet) {
              this.presentActionSheetGallery((uri) => {
                this.setFile(uri,(image) => {
                  let img = document.getElementsByClassName(class_lbl);
                  // console.log(img,"class => ",class_lbl,"document.getElementsByClassName("+this.ifvalnull(opts.generated_class_label,'name-capture-img')+")");
                  if (img.length > 0) {
                    img[0].textContent = image;
                  }
                });
              });
              this.stateActionSheet = false;
            }
          }
          if (event.target['classList'].contains(class_lbl)) {
            // if (this.stateActionSheet) {
              this.previewFoto(this.imageUrlSelected);
              // this.stateActionSheet = false;
            // }
          }
        });
      }
      if (cmpListeners == 'approve-overtime') {
        document.addEventListener("click", event => {
          if (event.target['classList'].contains(class_btn)) {
            // console.log(event);
            if (this.stateActionSheet) {
              this.presentActionSheetGallery((uri) => {
                this.setFile(uri,(image) => {
                  let img = document.getElementsByClassName(class_lbl);
                  // console.log(img,"class => ",class_lbl,"document.getElementsByClassName("+this.ifvalnull(opts.generated_class_label,'name-capture-img')+")");
                  if (img.length > 0) {
                    img[0].textContent = image;
                  }
                });
              });
              this.stateActionSheet = false;
            }
          }
          if (event.target['classList'].contains(class_lbl)) {
            // if (this.stateActionSheet) {
              this.previewFoto(this.imageUrlSelected);
              // this.stateActionSheet = false;
            // }
          }
        });
      }
    }
    /* SHOW SWAL */
    swal(
      this.ifvalnull(opts.title,"Information"), this.ifvalnull(opts.desc,""),this.ifvalnull(opts.type,""),
      {
        dangerMode:this.ifvalnull(opts.dangerMode,false),
        className: "popup-custom",
        buttons: opts.buttonConfirm === false ? ["Close"] : ["Cancel",this.ifvalnull(opts.buttonConfirm,"Submit")],
        content:{
          element:el,
        }
      }
    )
    .then((value) => {
      if (value) {
        successCallback(value);
      }else{
      }
    }); 
  }

  presentSwalConfirmation(opts?:any,successCallback?:any,failedCallback?:any,contentInput?:boolean ){
    if (contentInput) {
      swal(
        this.ifvalnull(opts.title,""), this.ifvalnull(opts.desc,""), this.ifvalnull(opts.icon,""),
        {
          dangerMode:this.ifvalnull(opts.dangerMode,false),
          className: this.ifvalnull(opts.className,"popup-prodictivity"),
          buttons:[this.ifvalnull(opts.btnCancel,"Cancel"),this.ifvalnull(opts.btnConfirm,'Yes')],
          content:{element:this.ifvalnull(opts.inputType,"input"),attributes:{placeholder:this.ifvalnull(opts.inputPlaceholder,"Enter here.."),rows:this.ifvalnull(opts.inputRows,4)}}
        }
      )
      .then((value) => {
        if (value) {
          console.log(value);
          successCallback(value);
        }else{
          if (failedCallback) {          
            failedCallback(value);
          }
        }
      }); 
    }else{
      swal(
        this.ifvalnull(opts.title,""), this.ifvalnull(opts.desc,""), this.ifvalnull(opts.icon,""),
        {
          dangerMode:this.ifvalnull(opts.dangerMode,false),
          buttons:[this.ifvalnull(opts.btnCancel,"Cancel"),this.ifvalnull(opts.btnConfirm,'Yes')],
        }
      )
      .then((value) => {
        if (value) {
          console.log(value);
          successCallback(value);
        }else{
          if (failedCallback) {          
            failedCallback(value);
          }
        }
      });
    }
  }



  presentToast(msg) {
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  showLoading(string) {
    let loading = this.loadingCtrl.create({
      content: string
    });
    loading.present();
    return loading;
  }

  dateToString(date, tipe = "dmy") {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    if (tipe == 'dmy') {
      return day + '/' + month + '/' + year;
    } else if (tipe == 'ymd') {
      return year + '-' + month + '-' + day;
    }

  }

  openCalendar(callback) {
    let me = this;
    let maskLoading = this.showLoading("Wait..");
    const options: CalendarModalOptions = {
      pickMode: 'range',
      from: this.startDate,
      canBackwardsSelected: true,
      title: 'Choose Date',
      defaultDateRange: this.valDateJarak,
      closeIcon: true,
      doneIcon: true,
      doneLabel: 'Done',
      closeLabel: 'Cancel'
    };

    let myCalendar = this.modalCtrl.create(CalendarModal, {
      options
    });

    myCalendar.present();
    try {
      maskLoading.dismiss();
    } catch (e) {

    }
    myCalendar.onDidDismiss((data, role) => {
      callback(data, role);
    });
  }

  getMonthString(index,languange){
    let month = {
      'indonesia' : {
        0:'Januari',
        1:'Februari',
        2:'Maret',
        3:'April',
        4:'Mei',
        5:'Juni',
        6:'Juli',
        7:'Agustus',
        8:'September',
        9:'Oktober',
        10:'November',
        11:'Desember',
      },
      'inggris' : {
        0:'Jan',
        1:'Feb',
        2:'March',
        3:'April',
        4:'May',
        5:'June',
        6:'Jul',
        7:'Aug',
        8:'Sept',
        9:'Oct',
        10:'Nov',
        11:'Dec',
      }
    };
    return month['languange']['index'];
  }

  findValueFromArrayObject(arr,name,k) {
    var out = -1;
    for (var i = 0; i < arr.length; i++) 
    {
        if (name in arr[i])
        {
            if(arr[i][name] == k)
            {
                out = i;
                break;
            }            
        }        
    }

    return out;
  }

  searchArrayByValueFromArrayObject(data,text_search,key){
    if (data && data.length > 0) {
      let newData = data.filter(row => {
        let search = new RegExp(text_search, 'gi');
        return row[key] == null ? null : row[key].match(search) != null;
      });
      return newData;
    }else{
      return [];
    }
  }

  random_string(start = 2,end = 15){
    return Math.random().toString(36).substring(start, end) + Math.random().toString(36).substring(start, end);
  }

  previewFoto(src){
    let random_string = this.random_string(10,15);
    let is_android = (!document.URL.startsWith('http') || document.URL.startsWith('http://localhost:8080'));
    console.log(this.platform,'is android = '+is_android,"is_browser = "+this.platform.is('browser'));
    if (is_android) {
      this.photoViewer.show(src);
    }else{
      // let cmp = document.createElement('div');
      // cmp.innerHTML = '<img src="'+src+'" id="myImgHelper-'+random_string+'" style="display:none">';
      // document.getElementById('wadah-helper')[0].append(cmp);
      let img = document.getElementById('img-preview-helper');
      img['src'] = src;
      let imageViewer = this.imageViewerCtrl.create(img);
      imageViewer.present();
  
      // setTimeout(() => imageViewer.dismiss(), 1000);
      // imageViewer.onDidDismiss(() => alert('Viewer dismissed'));
    }
    // try {
    // } catch (error) {
      
    // }
  }

  filterKaryawan(params,callback){
    let me = this;
    this.loading = this.showLoading("Load Data...");
    this.repositoryProvider.checkBeforeGetBawahan(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      if(resp.success){
        let karyawanModal = this.modalCtrl.create(cmpFilterKaryawan, {karyawan:resp.data.list,isAddHoc:resp.data.isAddHoc,fiturSearching:true,title:"My Team Profile",level:resp.data.level,all_data:params.all_data}, {cssClass: 'select-modal',enableBackdropDismiss:false });
        karyawanModal.onDidDismiss(karyawan => {
          callback(karyawan);
        });
        karyawanModal.present();
      }
    },(err) => {
      this.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    });    
  }

}



// WEBPACK FOOTER //
// ./src/providers/resources/helper.ts